import { FormContentWrapper } from './FormContent.styles';

export const FormContent = FormContentWrapper;
